module.exports = __webpack_public_path__ + "static/media/tigerPatch01.38fd71fe.jpeg";